import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const formatShortNumber = (num) => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(0)}K`;
  return num;
};

const TotalSpendChart = ({ activeTab }) => {
  const { lastThreeMetrics, currentMetrics, yearlyMetrics } = useSelector(
    (state) => state.metrics
  );

  const mapMetricsToChartData = (data) => {
    if (!Array.isArray(data)) return [];

    const flatData = data.flat();

    return flatData.map((item) => ({
      label: item.month,
      value: item.amount,
      supplierName: item.supplierName,
    }));
  };

  const chartDataPoints = React.useMemo(() => {
    switch (activeTab) {
      case "Monthly":
        return mapMetricsToChartData(currentMetrics?.metrics);
      case "Last 3 Months":
        return mapMetricsToChartData(lastThreeMetrics?.metrics);
      case "Yearly":
        return mapMetricsToChartData(yearlyMetrics?.metrics);
      default:
        return [];
    }
  }, [activeTab, currentMetrics, lastThreeMetrics, yearlyMetrics]);
  const chartData = {
    datasets: [
      {
        label: "Total Spend",
        data: chartDataPoints.map((d) => ({
          x: d.label,
          y: d.value,
          supplierName: d.supplierName,
        })),
        borderColor: "#3b82f6",
        borderWidth: 2,
        fill: false,
        tension: 0.4,
        pointRadius: 4,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    interaction: {
      mode: "nearest",
      intersect: false,
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items) => items[0].raw?.supplierName || "",
          label: (context) => {
            const amount = context.parsed.y;
            return `Amount: $${amount.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      x: {
        type: "category",
      },
      y: {
        beginAtZero: false,
        ticks: {
          callback: (value) => `$${formatShortNumber(value)}`,
        },
      },
    },
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-base font-semibold text-gray-900 mb-4 text-left">
        Total Spend on Suppliers
      </h2>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

export default TotalSpendChart;
